export const DEFAULT_URL_ARGUMENTS = "?lead_via_main_website=true";
export const CLUB_VISTARA_ARGUMENT = "lead_via_vistara=true";

export const APPLE_STORE_URL = "https://betheshyft.app.link/9XyFHTaDRub";
export const DUAL_STORE_LINK = "https://mindhouse.app.link";

export const DEFAULT_API_ERROR_MESSAGE =
  "Something went wrong, Please try again.";
